module.exports = __webpack_public_path__ + "img/tickets-tap.2ace6ebc.png";